module.exports = __webpack_public_path__ + "static/media/user-blue.501164ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user-blue.svg
// module id = 1560
// module chunks = 1